import React, { useEffect, useState } from 'react';
import './ConnectionOptions.scss';
import DiscoverHeader from '../../../components/DiscoverHeader/DiscoverHeader';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme
} from '@mui/material';
import DirectIntegrationTab from '../../../components/DirectIntegrationTab/DirectIntegrationTab';
import TechnologyPartnersTab from '../../../components/TechnologyPartnersTab/TechnologyPartnersTab';
import DesktopPlatformTab from '../../../components/DesktopPlatformTab/DesktopPlatformTab';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import ConnectionFooterBanner from "../../../components/connectionBanner/connectionBanner";

const ConnectionOptions = ({ ...props }) => {
  const urls = ['direct-integration', 'technology-partners', 'ac-connex'];
  const { t, i18n } = useTranslation();
  const json = t('ndc-program.connection-options', { returnObjects: true });
  const [activeTabIndex, setActiveTabIndex] = useState<number>(props.showTab);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  React.useEffect(
    ()=>{
      setActiveTabIndex(props.showTab)
    },
    [props.showTab]
  )

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (index: number) => {
    setActiveTabIndex(index);
    setAnchorEl(null);
    navigate(`/${i18n.language}/ndc-program/connection-options/${urls[index]}`);
    // history(`/ndc-program/connection-options/${urls[index]}`);
  };
  React.useEffect(() => {
    const handleScroll = () => {
      setAnchorEl(null);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });
  console.log(activeTabIndex);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tabsLabel = json['tabsLabel'];
  const breadcrumb = json['breadcrumb'];
  const ariaLabelMap = json['ariaLabelMap'];

  return (
    <>
      {json && (
        <main className="connection-options-container">
          <DiscoverHeader
            title={json['title']}
            paragraph={json['connection-options-header']}
            breadcrumb={breadcrumb}
            image="planeConnecImg.png"
            dropdown={true}
          />
          {isDesktop ? (
            <Box
              aria-label={ariaLabelMap}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                marginTop: '10px'
              }}
            >
              <Tabs
                value={activeTabIndex}
                aria-label="Connection Options Tabs"
                className="connectionTabs"
                sx={{
                  '& .MuiTab-root.Mui-selected': {
                    color: '#1460AA !important'
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#1460AA !important'
                  },
                  '& .MuiTabs-flexContainer': {
                    justifyContent: 'center'
                  }
                }}
              >
                {tabsLabel.map((label, index) => (
                  <Tab
                    key={`${label}-${index}`}
                    aria-controls={`tabpanel-${index}`}
                    value={index}
                    label={label}
                    onClick={() => handleMenuItemClick(index)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '14px',
                      fontWeight: 600,
                      ':hover': {
                        color: '#003D78'
                      },
                      '&:focus-visible': {
                        outline: '2px solid black',
                        outlineOffset: '-4px'
                      }
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                margin: '0px',
                width: '100%',

                '@media (max-width: 900px)': {
                  maxWidth: '704px'
                }
              }}
            >
              <Box
                className="selectDropdown"
                sx={{
                  px: 0,
                  py: 3,
                  backgroundColor: '#F9F9F9',
                  maxWidth: '1200px',
                  width: '100%',
                  marginX: '32px',

                  '@media (max-width: 900px)': {
                    maxWidth: '704px'
                  }
                }}
              >
                <List
                  component="nav"
                  aria-label={ariaLabelMap}
                  sx={{
                    width: '93%',
                    position: 'relative',
                    m: 0,
                    p: 0,
                    pl: '7%',
                    backgroundColor: '#F9F9F9',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      left: '7%', // start border 20px from left
                      right: 0,
                      borderBottom: '1px solid #c9cacc'
                    }
                  }}
                >
                  <ListItem
                    id="lock-button"
                    aria-haspopup="listbox"
                    aria-controls="lock-menu"
                    aria-label={tabsLabel[activeTabIndex]}
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickListItem}
                    sx={{
                      width: '100%',
                      px: 2,
                      py: 1.25,
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <ListItemText
                      primary={tabsLabel[activeTabIndex]}
                      primaryTypographyProps={{
                        sx: { fontWeight: 600, fontSize: '14px' }
                      }}
                    />
                    <ArrowDropDownIcon />
                  </ListItem>
                </List>
                <Menu
                  id="lock-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  keepMounted
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{
                    sx: {
                      width: '75%',
                      maxWidth: 'none',
                      borderRadius: '0 0 8px 8px ',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      '@media (max-width: 500px)': {
                        width: '72%'
                      }
                    }
                  }}
                  MenuListProps={{
                    'aria-labelledby': 'lock-button',
                    role: 'listbox',
                    sx: { p: 0 }
                  }}
                >
                  {tabsLabel.map((option: string, index: number) => (
                    <MenuItem
                      key={option}
                      disabled={index === activeTabIndex}
                      selected={index === activeTabIndex}
                      onClick={() => handleMenuItemClick(index)}
                      role="option"
                      aria-selected={index === activeTabIndex}
                      sx={{
                        width: '100%',
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#000000'
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Box>
          )}
          {
            [
              <DirectIntegrationTab jsonData={json} />,
              <TechnologyPartnersTab />,
              <DesktopPlatformTab jsonData={json} />
            ][activeTabIndex]
          }
        </main>
      )}
    </>
  );
};

export default ConnectionOptions;
